import { useSyncExternalStore } from 'react';

export default function useMediaQuery(query: string) {
	const subscribe = (onStoreChange: () => void) => {
		const mql = window.matchMedia(query);
		mql.addEventListener('change', onStoreChange);

		return () => mql.removeEventListener('change', onStoreChange);
	};

	const getSnapshot = () => window.matchMedia(query).matches;
	const getServerSnapshot = () => false;

	const matches = useSyncExternalStore(
		subscribe,
		getSnapshot,
		getServerSnapshot,
	);

	return { matches };
}
